import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
// import { environment } from "projects/customer-management/src/environments/environment";
import { Observable } from "rxjs";
import { EnvironmentService } from "./environment.service";
import { AddressMapping } from "../mappings/address.mapping";
import { map } from "rxjs/operators";
import { IAddressSearchModel } from "../models/address/address-search.model";
import { ICountryDtoModel } from "../models/country/country-dto.model";
import { IVerifyAddressDtoRequest, IVerifyAddressDtoResponse } from "../models/address/dto/verify-address-dto.model";
import { IAddressModel } from "../models/address/address.model";

const httpOptionsWithClientId = {
    headers: new HttpHeaders({
      'X-Client-Id':'2FC6E2AC-18D6-462E-A662-FF6BC75968C9',
    })
  };

@Injectable({
    providedIn: 'root'
  })
export class LocationService {
  googleApiKey: string = 'AIzaSyDhpkUBy5jrWIfWM1M-BOLkhBhgsgOYl2Y';
  private fullPath: string;
  private fullPathVerify: string;
  private addressMapping: AddressMapping = new AddressMapping();
    constructor(private httpClient: HttpClient,
      public envService: EnvironmentService) {
       this.fullPath = `https://web-api.sngbarratt.com/address/capture`;
       this.fullPathVerify = `https://web-api.sngbarratt.com/address/verify`;
    }

    public find(search: IAddressSearchModel): Observable<string[]> {
        return this.httpClient.post<string[]>(this.fullPath, search, httpOptionsWithClientId);
    }

    public getAllCountries(): Observable<ICountryDtoModel[]> {
      return this.httpClient.get<ICountryDtoModel[]>(`${this.envService.settings.apiUrl}/Options/countries`);
    }

    public verify(search: IVerifyAddressDtoRequest): Observable<IVerifyAddressDtoResponse> {
      return this.httpClient.post<IVerifyAddressDtoResponse>(this.fullPathVerify, search, httpOptionsWithClientId);
    }


    public getAddressResultDetails(model: IAddressSearchModel, searchTerm: string, index: number): Observable<IAddressModel> {

      model.address = searchTerm;

      return this.httpClient.post<string>(`${this.fullPath}/${index}`, model, httpOptionsWithClientId)
      .pipe(
        map(m => this.addressMapping.toApplicationModelFromString(m))
      )
    }

    getCountryCode = (restrictToBranches: boolean) => {
      let cc$ = new Observable((observer) => {
        navigator.geolocation.getCurrentPosition((position) => {
          let url;
          if (position) {
            url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=` + position.coords.latitude + `,` + position.coords.longitude + `&key=AIzaSyDhpkUBy5jrWIfWM1M-BOLkhBhgsgOYl2Y`;
          } else {
            url = false
          }
          observer.next(url)
        })
      })
      return cc$;
    }
  
  
    getCurrentPosition = (url: string, restrictToBranches: boolean) => {
  
      let response$ = new Observable((observer) => {
  
        let country:any;
        return this.httpClient.get(url)
          .subscribe((res: any) => {
            //get the position from google api
            let locations = res.results;
            if (res.status == 'OK') {
              if (locations[1]) {
                for (let i = locations[0].address_components.length - 1; i >= 0; i--) {
                  for (let b = 0; b < locations[0].address_components[i].types.length; b++) {
                    if (locations[0].address_components[i].types[b] == 'country') {
                      //country code
  
                      country = locations[0].address_components[i];
                      break;
                    }
                  }
                }
  
                if (restrictToBranches) {
                  switch (country.short_name) {
                    case 'GB':
                      res.cc = 'UK';
                      break;
                    case 'UK':
                      res.cc = 'UK';
                      break;
                    case 'AU':
                      res.cc = 'UK';
                      break;
                    case 'IS':
                      res.cc = 'UK';
                      break;
                    case 'IE':
                      res.cc = 'NL';
                      break;
                    case 'NO':
                      res.cc = 'UK';
                      break;
                    case 'US':
                      res.cc = 'US';
                      break;
                    case 'NL':
                      res.cc = 'NL';
                      break;
                    case 'BG':
                      res.cc = 'NL';
                      break;
                    case 'RO':
                      res.cc = 'NL';
                      break;
                    case 'HU':
                      res.cc = 'NL';
                      break;
                    case 'SI':
                      res.cc = 'NL';
                      break;
                    case 'SK':
                      res.cc = 'NL';
                      break;
                    case 'BE':
                      res.cc = 'NL';
                      break;
                    case 'CZ':
                      res.cc = 'NL';
                      break;
                    case 'CY':
                      res.cc = 'NL';
                      break;
                    case 'PL':
                      res.cc = 'NL';
                      break;
                    case 'DK':
                      res.cc = 'NL';
                      break;
                    case 'SE':
                      res.cc = 'NL';
                      break;
                    case 'FI':
                      res.cc = 'NL';
                      break;
                    case 'EE':
                      res.cc = 'NL';
                      break;
                    case 'LV':
                      res.cc = 'NL';
                      break;
                    case 'LT':
                      res.cc = 'NL';
                      break;
                    case 'DE':
                      res.cc = 'DE';
                      break;
                    case 'AT':
                      res.cc = 'DE';
                      break;
                    case 'CH':
                      res.cc = 'DE';
                      break;
                    case 'FR':
                      res.cc = 'FR';
                      break;
                    case 'PT':
                      res.cc = 'FR';
                      break;
                    case 'ES':
                      res.cc = 'FR';
                      break;
                    case 'IT':
                      res.cc = 'FR';
                      break;
                    case 'GR':
                      res.cc = 'FR';
                      break;
                    case 'MT':
                      res.cc = 'FR';
                      break;
                    case 'AL':
                      res.cc = 'FR';
                      break;
                    case 'MK':
                      res.cc = 'FR';
                      break;
                    case 'XK':
                      res.cc = 'FR';
                      break;
                    case 'ME':
                      res.cc = 'FR';
                      break;
                    case 'RS':
                      res.cc = 'FR';
                      break;
                    case 'BA':
                      res.cc = 'FR';
                      break;
                    case 'HR':
                      res.cc = 'FR';
                      break;
                    default:
                      res.cc = 'UK';
                  }
                } else {
                  res.cc = country.short_name;
                }
  
                return res.cc;
              }
  
  
              //couldnt find country code
            } else {
              res.cc = false;
              return res.cc;
            }
  
            observer.next(res)
          }, error => {
            //handle error
            observer.next(false)
          })
      })
      return response$;
    }

 
}